import { Button } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useInviteInvestorModal } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/hooks/useInviteInvestorModal.ts';
import { SendInvitationModal } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/SendInvitationModal/SendInvitationModal.tsx';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	investorId: string;
	onClose: () => void;
}

export const InviteInvestorButton = ({ investorId, onClose }: Props) => {
	const tMipManage = useTranslationMipManage();
	const {
		modalOpened,
		openModal,
		closeModal,
		investors,
		sendInvitations,
		isLoading,
		isDisabled,
	} = useInviteInvestorModal({ investorId, onClose });

	return (
		<>
			<Button
				data-testid={TEST_ELEMENT_IDS.MIP_MANAGE_INVESTORS_DETAILS_INVITATION_BUTTON}
				size="md"
				fw={600}
				variant="filled"
				disabled={isDisabled}
				onClick={openModal}
				leftSection={
					<Icon
						variant="lightning-fast-speed"
						size="lg"
						color="#fff"
						fillStroke={true}
						style={{ marginRight: '0.75rem' }}
					/>
				}
			>
				{tMipManage('investors.details.invite_button')}
			</Button>

			{modalOpened && (
				<SendInvitationModal
					key={investors.length}
					onClose={closeModal}
					sendInvitation={sendInvitations}
					isLoading={isLoading}
					investors={investors}
				/>
			)}
		</>
	);
};
